var base = require('kiosk/metrics');

Vue.component('spark-kiosk-metrics', {
  mixins: [base],
  methods: {
    // Override broken drawChart method in Spark
    drawChart(id, days, dataGatherer, scaleLabelFormatter) {
      var dataset = this.baseChartDataSet;

      dataset.data = _.map(_.last(this.indicators, days), dataGatherer);

        // Here we will build out the dataset for the chart. This will contain the dates and data
        // points for the chart. Each chart on the Kiosk only gets one dataset so we only need
        // to add it a single element to this array here. But, charts could have more later.
      var data = {
          labels: _.last(this.availableChartDates, days),
          datasets: [dataset]
      };

      var options = { responsive: true };

        // If a scale label formatter was passed, we will hand that to this chart library to fill
        // out the Y-Axis labels. This is particularly useful when we want to format them as a
        // currency as we do on all of our revenue charts that we display on the Kiosk here.
      if (arguments.length === 4) {
          options.scaleLabel = scaleLabelFormatter;
      }

      var chart = new Chart(document.getElementById(id).getContext('2d'))
        .Line(data, options);
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/kiosk/metrics.js